/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Media from 'react-media';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import {
    array, bool, func, number, string,
} from 'prop-types';

import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import ProductFacetsV4 from '../../GraphqlCategoryPage/Partials/ProductFacetsV4/ProductFacetsV4';

const useStyles = makeStyles(() => ({
    facetRoot: {
        margin: '0px 7px 96px',
    },
    productFacetHidden: {
        display: 'none',
    },
}));

function GraphqlSearchFacetFilter({
    desktop = false,
    productFacetsGroup,
    setFilterData,
    productCount,
    productLoading,
    searchTerm,
}) {
    const classes = useStyles();
    const ssrDeviceType = useSelector(getSSRDeviceType);
    return (
        <Media
            queries={{
                small: '(max-width: 598px)',
                medium: '(min-width: 599px) and (max-width: 1024px)',
                large: '(min-width: 1025px)',
            }}
            defaultMatches={{
                small: ssrDeviceType === 'mobile',
                medium: ssrDeviceType === 'desktop',
                large: ssrDeviceType === 'desktop',
            }}
        >
            {(matches) => {
                let facetClassName = classes.productFacetHidden;

                if (matches.large && desktop) {
                    facetClassName = classes.facetRoot;
                } else if (!desktop && (matches.small || matches.medium)) {
                    facetClassName = '';
                }

                return (
                    <div className={facetClassName}>
                        <ProductFacetsV4
                            productFacets={productFacetsGroup}
                            isDesktop={matches.large && desktop}
                            productCount={productCount}
                            loading={productLoading}
                            setFacetsDataInCollection={(data) => setFilterData(data, true)}
                            disableSort
                            searchPage
                            searchTerm={searchTerm}
                        />
                    </div>
                );
            }}
        </Media>
    );
}

GraphqlSearchFacetFilter.propTypes = {
    desktop: bool,
    productFacetsGroup: array.isRequired,
    setFilterData: func.isRequired,
    productCount: number,
    productLoading: bool,
    searchTerm: string,
};

GraphqlSearchFacetFilter.defaultProps = {
    desktop: false,
    productCount: 0,
    productLoading: false,
    searchTerm: '',
};

export default GraphqlSearchFacetFilter;
